@if (isButtonVariant()) {
  <ddc-button-n-two
    [_icon]="command().icon"
    [_label]="command().label"
    [_size]="buttonSize()"
    [class.disabled]="!isEnabled()"
    [matTooltip]="tooltipText()"
    (click)="onExecute()"
  />
} @else {
  <button
    mat-icon-button
    matTooltipPosition="right"
    [disabled]="!isEnabled()"
    [matTooltip]="tooltipText()"
    (click)="onExecute()"
  >
    @if (isSpinning()) {
      <span class="spinner-wrapper"><div class="spinner"></div></span>
    } @else {
      <mat-icon [style.color]="iconColor()">{{ command().icon }}</mat-icon>
    }
  </button>
}
